import { EdgeBase } from './EdgeBase';

export class EdgeSlave extends EdgeBase
{
	protected _role="slave";
	
	public async connect(authData=null)
	{
		try {
			if (this.getConnectTime() === null) {
				
				var rxData			= await this.getRequest("subscribe", authData).get();
				this._connectTime	= this.getAuto().get("utilities").getTime().getMicroEpoch(true);
				return rxData;
				
			} else if (this.getTerminated() === true) {
				throw this.getAuto().newException("Subscription no longer active");
			} else {
				throw this.getAuto().newException("Already connected");
			}
		} catch (e) {
			throw e;
		}
	}
	public disconnect(authData=null, type="unsubscribe")
	{
		if (this.getConnectTime() !== null) {
			
			if (this.getParent().getTerminated() === false) {
				this.getRequest(type, authData).setTimeout(0).exec();
			}
			this._isTerm	= true;
			this.getParent().removeSubscriber(this);
		}
		return this;
	}
	public terminate(notifyObj=null, event=null)
	{
		if (this.getTerminated() === false) {
			this._isTerm	= true;
			this.disconnect(null, "termination");
			this.getParent().removeSubscriber(this);
		}
	}
}